export default "__VITE_ASSET__BG8Y3yl2__"